import React, { FC } from 'react'
import { CartOrdersV3Query } from '~/app/components/order-list/hooks/useOrderListLoader'
import OrderListCard from '~/app/components/order-list/OrderListCard'

/**
 * OrderList component
 * author: soojin.oh
 */

// type definitions
type Props = {
  currentAt: string
  orderList: CartOrdersV3Query
  onDetailButtonClick?: (id: string) => void
  onProductClick?: (id: string, url: string, deeplink?: string) => void
  onProductImpr?: (id: string) => void
  onCancelRefreshButtonClick?: () => void
  storePreviewOrderListInfo: () => void
}

// OrderList component
const OrderList: FC<Props> = function ({
  currentAt,
  orderList,
  onDetailButtonClick,
  onProductClick,
  onProductImpr,
  onCancelRefreshButtonClick,
  storePreviewOrderListInfo,
}) {
  return (
    <>
      {orderList.map((order, index) => (
        <OrderListCard
          currentAt={currentAt}
          order={order}
          key={order.id}
          index={index}
          onDetailsButtonClick={onDetailButtonClick}
          onProductClick={onProductClick}
          onProductImpr={onProductImpr}
          onCancelRefreshButtonClick={() => onCancelRefreshButtonClick?.()}
          storePreviewOrderListInfo={storePreviewOrderListInfo}
        />
      ))}
    </>
  )
}

export default OrderList
